import { Modal } from 'antd';
import { ProTable } from '@ant-design/pro-components';
function SurchargeModal ({ open, setOpen, data }) {
    const columns = [
        {
            title: `费用名称`,
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: `费用金额`,
            dataIndex: 'amount',
            key: 'amount',
        }
    ]
    return (
        <Modal
            open={open}
            width={1000}
            title={`费用详情`}
            onCancel={() => {
                setOpen(false);
            }}
            footer={null}
        >
            <ProTable
                size="small"
                columns={columns}
                rowKey={(record) => record.key}
                pagination={false}
                dataSource={data}
                search={false}
                options={false}
            />
        </Modal>
    )
}

export default SurchargeModal;